import { Badge } from '@adop/ui';
import type { BadgeVariant } from '@adop/ui';
import type { RestaurantStatus } from '@adop/shared';

const VARIANTS: Record<RestaurantStatus, BadgeVariant> = {
  active: 'success',
  suspended: 'danger',
};

const LABELS: Record<RestaurantStatus, string> = {
  active: 'Active',
  suspended: 'Suspended',
};

export function AdminRestaurantStatusBadge({ status }: { status: RestaurantStatus }) {
  return <Badge variant={VARIANTS[status] ?? 'default'}>{LABELS[status] ?? status}</Badge>;
}
